import { render } from "./crawling.svg?vue&type=template&id=094617ee"
const script = {}
script.render = render

export default script